//
export const TranscodeTypes = {
  IMAGE: 'Image',
  VIDEO: 'Video',
  IMAGE_SEQUENCE: 'Image Sequence',
  GIF: 'Gif',
  MODEL: 'Model', // GLB 3D model — no transcode, raw upload
};
// Key/Values for user features
export const FeatureTypes = {
  GOD_MODE: 0,
  PANELS: 1,
  PANELS_UNLIMITED: 2,
  UNITY_ZIP: 3,
};

export const ArtworkFileTypes = {
  COVER_IMAGE: 'ImageCover',
  IMAGE: 'IMAGE',
  VIDEO_OPAQUE: 'Video',
  VIDEO_ALPHA: 'VideoAlpha',
};

// Supported media file extensions for Panels assets (images, videos, GIF, GLB).
// Shared by the scene drop (PanelsEditPage) and the FileSelect drop/ingest so a
// drop with no usable media is rejected with a warning instead of silently
// opening the asset modal. Unity .zip packs are handled separately (gated by a
// feature flag), so they are not included here.
export const PanelsAssetExtensions = [
  '.mov', '.mp4', '.m4v', '.avi', '.mkv', // video
  '.jpg', '.jpeg', '.png',                // image
  '.gif',                                 // animated gif
  '.glb',                                 // 3D model
];

// Panels Consts...
export const AssetTypes = {
  IMAGE: 'Image',
  VIDEO_OPAQUE: 'Video',
  VIDEO_ALPHA: 'VideoAlpha',
  GLB: 'Glb'
};
export const ControlModeTypes = {
  DEFAULT: 0,
  SELECT: 1,
  NAVIGATE_SCENE: 2, // For click and drag controls
  PRE_TRANSFORM: 3, // For hover transforming
  TRANSFORM: 4 // For transforming
};
export const TransformControlModeTypes = {
  TRANSLATE: 'translate',
  ROTATE: 'rotate',
  SCALE: 'scale'
};
export const TransformControlsSpaceTypes = {
  WORLD: 'world',
  LOCAL: 'local'
};


/**
 * Helper function to warn incorrect key types
 *
 * @param {Object} constObject
 * @param {String} key - Key of const object that we're trying to access
 * @returns
 */
function safelyGetConstant(constObject, key) {
  const value = constObject[key];
  if (value === undefined)
    console.warn(`Attemped to get ${key} from object but ${key} is not a valid key.  Valid values are ${Object.leys(constObject)}`);
  return value;
}

export const ConstantsPlugin = {
  install(Vue) {
    Vue.prototype.$featureTypes = key => safelyGetConstant(FeatureTypes, key);
    Vue.prototype.$transcodeTypes = key => safelyGetConstant(TranscodeTypes, key);
    Vue.prototype.$panelsTypes = {
      asset: key => safelyGetConstant(AssetTypes, key),
      controlMode: key => safelyGetConstant(ControlModeTypes, key),
      transformControlMode: key => safelyGetConstant(TransformControlModeTypes, key),
      transformControlSpace: key => safelyGetConstant(TransformControlsSpaceTypes, key)
    };
  }
};


export default {
  TranscodeTypes,
  FeatureTypes,
  ArtworkFileTypes,
  AssetTypes,
  ControlModeTypes,
  TransformControlModeTypes,
  TransformControlsSpaceTypes,
  ConstantsPlugin
};
